import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppContext, BillingService, SeoService } from './../shared';


declare const moment;

@Component({
  template: require('./account.component.html'),
  styles: [require('./account.component.scss')],
})
export class AccountComponent implements OnInit {
  trialEnd: string = '';
  trialLeft: number = 0;
  paidStart: string = '';
  showTrialBanner: Boolean = false;
  title = 'My Account';
  description = 'My Linescape Account';

  constructor(private router: Router, private app: AppContext, private billing: BillingService, private seo: SeoService) {
  }

  ngOnInit() {
    this.seo.set(this.title, this.description);
    if (!this.app.isLoggedIn) {
      this.router.navigate(['']);
    }
    this.trialEnd = '';
    this.trialLeft = 0;
    this.paidStart = '';
    this.showTrialBanner = false;
    this.update();
  }

  update() {
    this.billing.getCustomer().then(customer => {
      try {
        if (customer.subscriptions[0].status === 'trialing') {
          this.trialEnd = moment.unix(customer.subscriptions[0].trialEnd).format('YYYY-MM-DD');
          this.paidStart = moment.unix(customer.subscriptions[0].trialEnd).add(1, 'day').format('YYYY-MM-DD');
          this.showTrialBanner = true;
          this.trialLeft = moment.unix(customer.subscriptions[0].trialEnd).add(1, 'day').diff(moment(), 'days');

          if (this.trialLeft < 0) {
            this.showTrialBanner = false;
          }
        }
      } catch (ex) {
        this.showTrialBanner = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/account.component.ts